import { useEffect, useState, useCallback } from "react";
import { loadPublicProfilesByRole, loadSinglePublicProfile } from "@/services/publicProfile.service";
import type { PublicProfile } from "@/components/profile/PublicProfileCard";

export function usePublicProfiles(
  roles: Array<"broker" | "consultant" | "partner">
) {
  const [profiles, setProfiles] = useState<PublicProfile[]>([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState<string | null>(null);

  const rolesKey = roles.join(",");

  const load = useCallback(async () => {
    setLoading(true);
    setError(null);
    try {
      const results = await loadPublicProfilesByRole(roles);
      setProfiles(results);
    } catch (err: any) {
      console.error("[usePublicProfiles]", err);
      setError(err?.message || "Failed to load profiles");
    } finally {
      setLoading(false);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [rolesKey]);

  useEffect(() => {
    load();
  }, [load]);

  return { profiles, loading, error, reload: load };
}

export { loadSinglePublicProfile as loadPublicProfile };
